/**
 * 阿里云 OSS 图片缩略图 URL 派生工具。
 *
 * 只做「按展示尺寸等比缩小」，不修改源数据、不改压缩质量：
 * - lfit（contain 场景）：等比缩放，限制在 w x h 内；
 * - mfit（cover 场景）：等比缩放，短边撑满 w x h，避免浏览器 cover 裁切时放大取样不足的小图；
 * - limit_1：不放大小图；
 * - DPR 最高取 2（高分屏多取一倍像素，3x 屏不再翻倍下载）；
 * - 已带 x-oss-process（如旋转）、签名参数、data:/blob: 的地址一律原样返回，绝不覆盖；
 * - 有 #fragment 时参数插在 fragment 之前，保证生效于 HTTP query。
 */
var OSS_PROCESS = 'x-oss-process';
var SIGNED_PARAM = /(^|[?&])(OSSAccessKeyId|Signature|Expires|x-oss-signature)=/i;
function getDpr() {
    var raw = typeof window !== 'undefined' ? window.devicePixelRatio : 1;
    return Math.min(Math.max(raw || 1, 1), 2);
}
/**
 * 给图片地址追加阿里云缩略图参数。
 * @param url 图片地址（相对路径或完整 URL）
 * @param width 展示宽度（CSS 像素）
 * @param height 展示高度（CSS 像素）
 * @param fit lfit=contain 场景（默认）；mfit=background-size/object-fit:cover 场景
 */
export function ossThumbUrl(url, width, height, fit) {
    if (fit === void 0) { fit = 'lfit'; }
    if (!url)
        return '';
    if (/^(data|blob):/i.test(url))
        return url;
    // 参数检测只看 fragment 之前的 query 部分，避免把 #x-oss-process=… 之类的 hash 误判为已处理/已签名
    var hashIndex = url.indexOf('#');
    var hash = hashIndex === -1 ? '' : url.slice(hashIndex);
    var base = hashIndex === -1 ? url : url.slice(0, hashIndex);
    if (base.includes(OSS_PROCESS))
        return url;
    if (SIGNED_PARAM.test(base))
        return url;
    var dpr = getDpr();
    var w = Math.round(width * dpr);
    var h = Math.round(height * dpr);
    var process = "image/resize,m_".concat(fit, ",w_").concat(w, ",h_").concat(h, ",limit_1");
    var separator = base.includes('?') ? '&' : '?';
    return "".concat(base).concat(separator).concat(OSS_PROCESS, "=").concat(process).concat(hash);
}
